import { render, staticRenderFns } from "./PilotCard.vue?vue&type=template&id=e80f69d2&scoped=true&"
import script from "./PilotCard.vue?vue&type=script&lang=ts&"
export * from "./PilotCard.vue?vue&type=script&lang=ts&"
import style0 from "./PilotCard.vue?vue&type=style&index=0&id=e80f69d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80f69d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VCardText,VDivider,VFadeTransition,VHover,VImg,VOverlay})
